import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName';
import Number from './Number';
import ShortText from './ShortText';
import SingleChoice from './SingleChoice';
import Phone from './Phone';
import Address from './Address';
import ProductList from './ProductList';
import LongText from './LongText';

const SchoolUniformOrderForm = () => {


    const genderData  = [
        {
            id: 1,
            label: "دختر",
            checked: false
        },
        {
            id: 2,
            label: "پسر",
            checked: false
        },
    ]


    const deliveryData  = [
        {
            id: 1,
            label: "حمل و نقل استاندارد",
            checked: false
        },
        {
            id: 2,
            label: "تحویل حضوری در فروشگاه",
            checked: false
        },
    ]


    const paymentData  = [
        {
            id: 1,
            label: "پرداخت نقدی هنگام تحویل/دریافت",
            checked: false
        },
        {
            id: 2,
            label: "حواله بانکی",
            checked: false
        },
        {
            id: 3,
            label: "سفارش خرید",
            checked: false
        },
    ]


    const productList = [
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
    ]



  return (
    <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
    <Heading header={'فرم سفارش لباس فرم مدرسه'} subHeader={''} />
    <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
        <FullName header={'نام دانش آموز'} />
        <Number header={'سن'}/>
        <ShortText header={'کلاس/بخش'} />
        <SingleChoice header={'جنسیت'} options={genderData}/>
        <FullName header={'نام والدین/سرپرست'}/>
        <ShortText header={'نسبت'} />
        <Phone header={'شماره تلفن'}/>
        <Address header={'آدرس'}/>
        <Heading header={'جزئیات سفارش'}/>
        <SingleChoice header={'نوع تحویل'} options={deliveryData}/>
        <ProductList header={'محصولات را انتخاب کنید'} product={productList}/>
        <SingleChoice header={'روش پرداخت'} options={paymentData}/>
        <LongText header={'ملاحظات/یادداشت‌ها'}/>
    </Grid>
</Grid>
  )
}

export default SchoolUniformOrderForm
